<i18n>
{
  "en": {
    "title": "EcoStruxure Energy & Sustainability Services Highlights 2017-2018 — Schneider Electric",
    "description": "Schneider Electric Energy & Sustainability Services help companies in making the shift to active energy management and in their sustainability development. Learn how ESS helps design energy strategies, deliver energy efficiency, and sustain results through long-term energy services.",
    "sustainable": {
      "section": "Sustainable Solutions",
      "title": "EcoStruxure Energy & Sustainability Services",
      "services": {
        "vid": {
          "title": "The Mission of EcoStruxure Energy & Sustainability Services",
          "description": "Steve Wilhite, SVP of Energy & Sustainability Services, Schneider Electric"
        },
        "vid2": {
          "title": "More Sustainable Entertainment",
          "desc": "Setting the standard for a global audience"
        },
        "vid3": {
          "title": "Waste Not, Want Not",
          "desc": "Championing cultural change from factory to home"
        },
        "vid4": {
          "title": "Changing Sustainability Perceptions",
          "desc": "A business-oriented approach to sustainability"
        },
        "development": {
          "title": "A partner for sustainable development",
          "para": "Through EcoStruxure<sup>&trade;</sup> Energy & Sustainability Services, we help our clients design a strategy, deliver efficiency in their facilities, and sustain results over time through long-term partnerships.",
          "paraB": "We do this by:",
          "itemA": "Helping clients buy energy through strategic sourcing and renewable energy transactions",
          "itemB": "Providing energy efficiency services to reduce energy consumption and sustainability services to reduce footprint and improve transparency and reporting",
          "itemC": "Deploying our award-winning energy and sustainability software, EcoStruxure Resource Advisor",
          "paraC": "As an unbiased, independent consultant, we work with clients in more than 100 countries — from regional companies to the world’s largest corporations."
        },
        "essSnapshot": {
          "title": "ESS at a glance",
          "one": {
            "title": "$30",
            "unit": "billion",
            "para": "managed energy spend"
          },
          "two": {
            "title": "650,000",
            "unit": "utility invoices",
            "para": "collected and reviewed monthly"
          },
          "three": {
            "title": "40",
            "unit": "million metric tons",
            "para": "of CO<sub>2</sub> managed"
          },
          "four": {
            "title": "2,000+",
            "unit": "megawatts",
            "para": "in renewable energy transactions (power purchase agreements) in 2017"
          }
        },
        "energyGrid": {
          "one": {
            "title": "Buy energy smarter",
            "itemA": "Strategic sourcing",
            "itemB": "Risk management",
            "itemC": "Rate analysis",
            "itemD": "Market intelligence",
            "itemE": "Energy budgets"
          },
          "two": {
            "title": "Reduce energy use",
            "itemA": "Energy efficiency consulting",
            "itemB": "Remote energy monitoring",
            "itemC": "Data collection and management"
          },
          "three": {
            "title": "Operate sustainably",
            "itemA": "Sustainability strategy",
            "itemB": "Climate change compliance",
            "itemC": "Sustainability reporting",
            "itemD": "Sustainable operations",
            "itemE": "Water and waste optimization",
            "itemF": "Renewables and cleantech"
          }
        },
        "barometer": {
          "title": "2015 – 2017 Planet <span class='t-nowrap'>&amp; Society</span> barometer achievements",
          "cta": "See the full results",
          "one": {
            "title": "Climate &amp; Development (Sustainability offers)",
            "stat": "168,400 tons",
            "body": "of CO<sub>2</sub> avoided through maintenance, retrofit, and end-of-life services"
          }
        },
        "energyManagement": {
          "title": "Shifting to active energy management",
          "para": "Advances in energy markets and technologies have given companies more control over how they use energy, how much that energy costs, and how that energy is sourced. Active energy management is the process of integrating energy supply, energy demand, and sustainability data, programs, and strategies for greater efficiency and maximum results. This means that an organization’s procurement officer, operations manager, and sustainability director work together to form a cohesive strategy, share data, and deploy joint initiatives.",
          "paraB": "Our EcoStruxure Energy & Sustainability Services help our customers make the shift."
        },
        "energyManagmentExamples": {
          "title": "Examples of active energy management",
          "one": {
            "para": "Demand response programs based on real-time price signals"
          },
          "two": {
            "para": "Combining renewable energy strategies"
          },
          "three": {
            "para": "Efficiency programs to reach CO<sub>2</sub> reduction goals"
          },
          "four": {
            "para": "Using utility invoices to comply with energy management and sustainability compliance programs"
          }
        },
        "impact": {
          "title": "Highlights: ESS’s impact for our customers",
          "subtitle": "AEG",
          "para": "The right tools and data make AEG<sup>®</sup> a more profitable and sustainable company.",
          "paraB": "Results:",
          "itemA": "Visibility to 53 different types of data streams across 59 facilities in one central platform",
          "itemB": "$3 million+ savings",
          "itemC": "53% of worldwide waste diverted from landfill",
          "itemD": "14% reduction in GHG emissions from 2010 baseline"
        },
        "whirlpool": {
          "title": "Whirlpool",
          "para": "Data and expert support are helping Whirlpool<sup>®</sup> achieve its sustainability strategy.",
          "paraB": "Results:",
          "itemA": "Three plants achieved zero-waste-to-landfill",
          "itemB": "Saved more than $1 million over the next three years through corrugated cardboard recycling"
        },
        "blackstone": {
          "title": "Blackstone",
          "para": "Innovative technology and services allow Blackstone to pursue an aggressive and sustainable energy-management strategy.",
          "paraB": "Results:",
          "itemA": "Tens of millions in energy savings over six years"
        },
        "references": {
          "one": "<sup>2</sup> Based on a recent internal survey of clients at the Energy & Sustainability Perspectives Summit."
        }
      }
    }
  },
  "fr": {
    "title": "EcoStruxure Energy & Sustainability Services Highlights 2017-2018 — Schneider Electric",
    "description": "Schneider Electric Energy & Sustainability Services help companies in making the shift to active energy management and in their sustainability development. Learn how ESS helps design energy strategies, deliver energy efficiency, and sustain results through long-term energy services.",
    "sustainable": {
      "section": "Nos Solutions Durables",
      "title": "EcoStruxure Energy & Sustainability Services",
      "services": {
        "vid": {
          "title": "EcoStruxure pour Energy & Sustainability Services",
          "description": "Steve Wilhite, Directeur Energy & Sustainability Services, Schneider Electric"
        },
        "vid2": {
          "title": "Des loisirs plus durables",
          "desc": "Mettre en place des standards pour le grand public"
        },
        "vid3": {
          "title": "Moins de déchets",
          "desc": "Défendre les changements de comportement du site industriel à la maison"
        },
        "vid4": {
          "title": "Changer les idées sur le développement durable",
          "desc": "Une approche économique du développement durable"
        },
        "development": {
          "title": "Un partenaire pour la durabilité",
          "para": "Avec EcoStruxure<sup>TM</sup> Energy & Sustainability Services (ESS), nous aidons nos clients à élaborer une stratégie, à améliorer l’efficacité de leurs installations et à obtenir des résultats durables à travers des partenariats de long terme.",
          "paraB": "Pour ce faire, nous :",
          "itemA": "Accompagnons nos clients dans leurs achats d’énergie en les conseillant sur l’approvisionnement stratégique et les transactions d'énergie renouvelable",
          "itemB": "Leur fournissons des services d’efficacité énergétique pour leur permettre de réduire leur consommation d'énergie, et des services de développement durable pour les aider à réduire leur empreinte écologique et à améliorer leur transparence et leur reporting",
          "itemC": "Déployons notre logiciel primé de gestion d’énergie et de promotion du développement durable, EcoStruxure Resource Advisor.",
          "paraC": "Nous travaillons dans plus de 100 pays comme consultant neutre et indépendant pour des clients allant de la PME au grand groupe international."
        },
        "essSnapshot": {
          "title": "ESS en quelques chiffres",
          "one": {
            "title": "$30",
            "unit": "milliards",
            "para": "gérés en matière de dépenses d’énergie"
          },
          "two": {
            "title": "650 000",
            "unit": "factures d’énergie",
            "para": "collectées et analysées chaque mois"
          },
          "three": {
            "title": "40",
            "unit": "millions de tonnes",
            "para": "de CO<sub>2</sub> gérées"
          },
          "four": {
            "title": "Plus de 2000 MW",
            "unit": "&nbsp;",
            "para": "de transactions d’énergie renouvelable (accords d'achat d'énergie) en 2017"
          }
        },
        "energyGrid": {
          "one": {
            "title": "Acheter l’énergie plus intelligemment",
            "itemA": "Approvisionnement stratégique",
            "itemB": "Gestion des risques",
            "itemC": "Analyse des taux",
            "itemD": "Veille de marché",
            "itemE": "Budgets énergétiques"
          },
          "two": {
            "title": "Réduire l'utilisation de l'énergie",
            "itemA": "Conseil en efficacité énergétique",
            "itemB": "Gestion à distance de l'énergie",
            "itemC": "Collecte et gestion des données"
          },
          "three": {
            "title": "Agir durablement",
            "itemA": "Stratégie développement durable",
            "itemB": "Conformité au changement climatique",
            "itemC": "Reporting développement durable",
            "itemD": "Opérations durables",
            "itemE": "Optimisation de l'eau et des déchets",
            "itemF": "Energies renouvelables et cleantech"
          }
        },
        "barometer": {
          "title": "Résultat du baromètre Planète & Société 2015 – 2017",
          "cta": "Voir l’ensemble des résultats.",
          "one": {
            "title": "CLIMAT ET DÉVELOPPEMENT (OFFRES DURABLES)",
            "stat": "168 400 tonnes",
            "body": "de CO<sub>2</sub> évitées grâce aux services de maintenance, récupération et fin de vie"
          }
        },
        "energyManagement": {
          "title": "Franchir le cap de la gestion active de l’énergie",
          "para": "Les progrès technologiques sur les marchés de l’énergie ont donné aux entreprises un meilleur contrôle sur l’utilisation de l’énergie, sur le coût de celle-ci et sur son approvisionnement. La gestion active de l’énergie est un processus consistant à combiner offre et demande d’énergie, données relatives au développement durable, programmes et stratégies pour plus d’efficacité et de meilleurs résultats. Ainsi, le directeur des achats, le directeur d’exploitation et le directeur du développement durable travaillent main dans la main pour élaborer une stratégie homogène, partager des informations et déployer des initiatives conjointes.",
          "paraB": "L'offre EcoStruxure Energy & Sustainability Services permet à  nos clients de franchir le cap."
        },
        "energyManagmentExamples": {
          "title": "Exemples de gestion active de l’énergie :",
          "one": {
            "para": "Programmes d'ajustement de la demande reposant sur les signaux de prix en temps réel"
          },
          "two": {
            "para": "Combinaison des stratégies en matière d’énergie renouvelable"
          },
          "three": {
            "para": "Programmes d’efficacité visant à réduire les émissions de CO<sub>2</sub>"
          },
          "four": {
            "para": "Utilisation des factures de fourniture d’énergie pour se conformer aux programmes de gestion de l’énergie et de promotion du développement durable"
          }
        },
        "impact": {
          "title": "Focus : l’impact des ESS pour nos clients",
          "subtitle": "AEG",
          "para": "Les bons outils et données font d’AEG<sup>®</sup> une entreprise plus rentable et plus durable.",
          "paraB": "Résultats :",
          "itemA": "53 types de flux d’information différents sur 59 sites visibles sur une seule et même plateforme centralisée",
          "itemB": "Plus de 3 millions de dollars d’économie",
          "itemC": "53 % des déchets produits dans le monde détournés de la décharge",
          "itemD": "14 % de réduction des émissions de GES par rapport à 2010"
        },
        "whirlpool": {
          "title": "Whirlpool",
          "para": "Grâce aux données et à l'appui de nos experts, Whirlpool<sup>®</sup> met en œuvre sa stratégie de développement durable.",
          "paraB": "Résultats :",
          "itemA": "3 usines ont atteint leur objectif de zéro déchet mis en décharge",
          "itemB": "L’entreprise prévoit d’économiser plus de 1 million de dollars au cours des 3 prochaines années grâce au recyclage de ses déchets de carton ondulé"
        },
        "blackstone": {
          "title": "Blackstone",
          "para": "Avec une technologie et des services innovants, Blackstone a mis au point une stratégie de gestion de l'énergie agressive et durable.",
          "paraB": "Résultats :",
          "itemA": "Des dizaines de millions d'économie d'énergie en 6 ans"
        },
        "references": {
          "one": "<sup>2</sup> enquête interne récente menée auprès des clients lors de la conférence consacrée aux perspectives en matière d’énergie et de développement durable."
        }
      }
    }
  }
}
</i18n>

<template>
  <div id="">
    <Hero :loResSrc="require('../../assets/img/sustainable/sustainable-solutions-energy-sustain-services-hero-lowres.jpg')" :hiResSrc="require('../../assets/img/sustainable/sustainable-solutions-energy-sustain-services-hero.jpg')" chapter="02" :section="$t('sustainable.section')" :title="$t('sustainable.title')"/>

    <section class="m-b-120 m-t-120">
      <Txt>
        <h2 v-html="$t('sustainable.services.development.title')"/>
        <p v-html="$t('sustainable.services.development.para')"/>
        <p v-html="$t('sustainable.services.development.paraB')"/>
        <ul>
          <li v-html="$t('sustainable.services.development.itemA')"/>
          <li v-html="$t('sustainable.services.development.itemB')"/>
          <li v-html="$t('sustainable.services.development.itemC')"/>
        </ul>
        <p v-html="$t('sustainable.services.development.paraC')"/>
      </Txt>
    </section>

    <hr>

    <section class="m-b-120 m-t-120">
      <YouTubeVideo videoId="VV0YTSzN8ms" :title="$t('sustainable.services.vid.title')" :description="$t('sustainable.services.vid.description')" :preview="require('@/assets/img/thumbnails/SSDHighlightVideo_SteveWilhite_Still.jpg')" />
    </section>

    <hr>

    <section class="m-b-120 m-t-120">
      <Snapshot>
        <div slot="above">
          <h2 id="essataglance" v-html="$t('sustainable.services.essSnapshot.title')" />
        </div>
        <SnapshotCard class="t-white" bgc="#3dcd58">
          <h4 v-html="$t('sustainable.services.essSnapshot.one.title')" />
          <p class="t-chartbody" v-html="$t('sustainable.services.essSnapshot.one.unit')"/>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('sustainable.services.essSnapshot.one.para')" />
        </SnapshotCard>

        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('sustainable.services.essSnapshot.two.title')" />
          <p class="t-chartbody t-green-light" v-html="$t('sustainable.services.essSnapshot.two.unit')" />
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.services.essSnapshot.two.para')" />
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#3dcd58">
          <h4 v-html="$t('sustainable.services.essSnapshot.three.title')" />
          <p class="t-chartbody" v-html="$t('sustainable.services.essSnapshot.three.unit')"/>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('sustainable.services.essSnapshot.three.para')" />
        </SnapshotCard>

        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('sustainable.services.essSnapshot.four.title')" />
          <p class="t-chartbody t-green-light" v-html="$t('sustainable.services.essSnapshot.four.unit')" />
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('sustainable.services.essSnapshot.four.para')" />
        </SnapshotCard>
      </Snapshot>
    </section>

    <section class="m-b-120 m-t-120 l-section-pad l-bg-white">
      <Table class="">
        <TableRow>
          <TableCell :bgimg="require('@/assets/img/sustainable/GettyImages-663800200.jpg')">
            <h3 id="buyenergysmarter" class="t-white" v-html="$t('sustainable.services.energyGrid.one.title')" />
          </TableCell>
          <TableCell>
            <ul>
              <li class="t-chartbody" v-html="$t('sustainable.services.energyGrid.one.itemA')"/>
              <li class="t-chartbody" v-html="$t('sustainable.services.energyGrid.one.itemB')"/>
              <li class="t-chartbody" v-html="$t('sustainable.services.energyGrid.one.itemC')"/>
              <li class="t-chartbody" v-html="$t('sustainable.services.energyGrid.one.itemD')"/>
              <li class="t-chartbody" v-html="$t('sustainable.services.energyGrid.one.itemE')"/>
            </ul>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell >
            <h3 id="reduceenergyuse" class="t-green-light" v-html="$t('sustainable.services.energyGrid.two.title')" />
          </TableCell>
          <TableCell bgc="#3dcd58">
            <ul>
              <li class="t-chartbody t-white" v-html="$t('sustainable.services.energyGrid.two.itemA')"/>
              <li class="t-chartbody t-white" v-html="$t('sustainable.services.energyGrid.two.itemB')"/>
              <li class="t-chartbody t-white" v-html="$t('sustainable.services.energyGrid.two.itemC')"/>
            </ul>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell :bgimg="require('@/assets/img/sustainable/GettyImages-861223590.jpg')">
            <h3 id="operatesustainably" class="t-white" v-html="$t('sustainable.services.energyGrid.three.title')" />
          </TableCell>
          <TableCell>
            <ul>
              <li class="t-chartbody" v-html="$t('sustainable.services.energyGrid.three.itemA')"/>
              <li class="t-chartbody" v-html="$t('sustainable.services.energyGrid.three.itemB')"/>
              <li class="t-chartbody" v-html="$t('sustainable.services.energyGrid.three.itemC')"/>
              <li class="t-chartbody" v-html="$t('sustainable.services.energyGrid.three.itemD')"/>
              <li class="t-chartbody" v-html="$t('sustainable.services.energyGrid.three.itemE')"/>
              <li class="t-chartbody" v-html="$t('sustainable.services.energyGrid.three.itemF')"/>
            </ul>
          </TableCell>
        </TableRow>
      </Table>
    </section>

    <section class="m-t-120 m-b-120">
      <Barometer>
        <h2 class="t-grey" slot="copy" v-html="$t('sustainable.services.barometer.title')"/>
        <CTA slot="copy" href="/static/PSBarometer-Q42017_results.pdf" :buttonText="$t('sustainable.services.barometer.cta')" target="_blank"/>
        <BarometerIndicator class="col-xs-18" color="#009530" :title="$t('sustainable.services.barometer.one.title')" :stat="$t('sustainable.services.barometer.one.stat')" :body="$t('sustainable.services.barometer.one.body')"/>
      </Barometer>
    </section>

    <section class="m-b-120 m-t-120 l-section-pad l-bg-white">
      <TxtMedia>
        <div slot="main-content">
          <h2 id="activeenergymanagement" class="m-b-35" v-html="$t('sustainable.services.energyManagement.title')"/>
          <p v-html="$t('sustainable.services.energyManagement.para')" />
          <p v-html="$t('sustainable.services.energyManagement.paraB')" />
          <h3 v-html="$t('sustainable.services.energyManagmentExamples.title')"></h3>
          <ul>
            <li v-html="$t('sustainable.services.energyManagmentExamples.one.para')"></li>
            <li v-html="$t('sustainable.services.energyManagmentExamples.two.para')"></li>
            <li v-html="$t('sustainable.services.energyManagmentExamples.three.para')"></li>
            <li v-html="$t('sustainable.services.energyManagmentExamples.four.para')"></li>
          </ul>
        </div>
        <div slot="sidebar" class="l-mw-360 l-center">
          <SvgContainer v-if="$i18n.locale === 'en'">
            <SSEnergyIG class="scaling-svg" />
          </SvgContainer>
          <SvgContainer v-if="$i18n.locale === 'fr'">
            <SSEnergyIGFR class="scaling-svg" />
          </SvgContainer>
        </div>
      </TxtMedia>
    </section>

    <section class="m-t-120 m-b-45">
      <Txt>
        <h2 id="essimpact" class="m-b-35" v-html="$t('sustainable.services.impact.title')"/>
      </Txt>
    </section>

    <section class="m-b-120">
      <YouTubeVideo class="m-b-50" videoId="WxHjnOYOYmk" :title="$t('sustainable.services.vid2.title')" :description="$t('sustainable.services.vid2.desc')" :preview="require('@/assets/img/thumbnails/Nov-23-15_Schneider_LA_491_web.jpg')" />

      <Txt>
        <h3 class="m-b-15" v-html="$t('sustainable.services.impact.subtitle')" />
        <p v-html="$t('sustainable.services.impact.para')" />
        <p class="m-0" v-html="$t('sustainable.services.impact.paraB')" />
        <ul class="m-0">
          <li v-html="$t('sustainable.services.impact.itemA')" />
          <li v-html="$t('sustainable.services.impact.itemB')" />
          <li v-html="$t('sustainable.services.impact.itemC')" />
          <li v-html="$t('sustainable.services.impact.itemD')" />
        </ul>
      </Txt>
    </section>

    <section class="m-b-120 m-t-120">
      <YouTubeVideo class="m-b-50" videoId="lG4ZyOeZfH4" :title="$t('sustainable.services.vid3.title')" :description="$t('sustainable.services.vid3.desc')" :preview="require('@/assets/img/thumbnails/May-23-2016-Schneider-whirlpool_23674.jpg')" />

      <Txt>
        <h3 class="m-b-15" v-html="$t('sustainable.services.whirlpool.title')"/>
        <p v-html="$t('sustainable.services.whirlpool.para')" />
        <p class="m-0" v-html="$t('sustainable.services.whirlpool.paraB')" />
        <ul class="m-0">
          <li v-html="$t('sustainable.services.whirlpool.itemA')" />
          <li v-html="$t('sustainable.services.whirlpool.itemB')" />
        </ul>
      </Txt>
    </section>

    <section class="m-b-120 m-t-120">
      <YouTubeVideo class="m-b-50" videoId="qm2aL1vNqEg" :title="$t('sustainable.services.vid4.title')" :description="$t('sustainable.services.vid4.desc')" :preview="require('@/assets/img/thumbnails/Schneider-NYC-0142.jpg')" />

      <Txt>
        <h3 class="m-b-15" v-html="$t('sustainable.services.blackstone.title')"/>
        <p v-html="$t('sustainable.services.blackstone.para')" />
        <p class="m-0" v-html="$t('sustainable.services.blackstone.paraB')" />
        <ul class="m-0">
          <li v-html="$t('sustainable.services.blackstone.itemA')" />
        </ul>
      </Txt>
    </section>

    <hr>

    <References class="m-b-30">
      <Reference v-html="$t('sustainable.services.references.one')"/>
    </References>

    <div class="l-content">
      <FooterNav
        nextRoute="SustainableSolutions_Research"
        prevRoute="SustainableSolutions_Ecostruxure" />
    </div>

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import Txt from '@/components/Txt'
import TxtMedia from '@/components/TxtMedia'
import References from '@/components/References'
import Reference from '@/components/Reference'
import YouTubeVideo from '@/components/YouTubeVideo'
import Snapshot from '@/components/Snapshot'
import SnapshotCard from '@/components/SnapshotCard'
import Barometer from '@/components/Barometer'
import BarometerIndicator from '@/components/BarometerIndicator'
import SvgContainer from '@/components/SvgContainer'
import Table from '@/components/Table'
import TableRow from '@/components/TableRow'
import TableCell from '@/components/TableCell'

import SSEnergyIG from '@/assets/img/ig/sustainable-solutions-energy-sustain.svg'
import SSEnergyIGFR from '@/assets/img/ig/sustainable-solutions-energy-sustain_french.svg'

export default {
  name: 'SustainableSolutions_EnergyServices',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Txt,
    TxtMedia,
    FourCols,
    FourColsItem,
    CTA,
    Reference,
    References,
    YouTubeVideo,
    Snapshot,
    SnapshotCard,
    Barometer,
    BarometerIndicator,
    SvgContainer,
    SSEnergyIG,
    SSEnergyIGFR,
    Table,
    TableRow,
    TableCell
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/sustainable-solutions/energy-services.vue